<template>
  <el-dialog-zdy
    append-to-body
    title="认证记录" :visible.sync="visible" width="80%">
    <el-row>
      <el-col :span="8" class="left-box">
        <div>
          <p class="left-title">原始图片</p>
          <el-image
            style="height: 280px"
            :src="userInfo.faceImageUrl"
            fit="contain">
            <div slot="error" class="image-slot">
              <div slot="error" class="image-slot">
                <span>员工还未进行认证图片上传</span>
              </div>
            </div>
          </el-image>
        </div>
      </el-col>
      <el-col :span="16">
        <el-table :data="dataList" v-loading="loading" element-loading-text="拼命加载中" class="mb20" height="500">
          <el-table-column prop="resourcesDataName" label="课件名称" width="180"></el-table-column>
          <el-table-column prop="resourcesName" label="附件名称" width="180"></el-table-column>
          <el-table-column label="认证图片" width="400">
            <template slot-scope="scope">
              <template v-if="scope.row.vimageList">
                <el-image
                  v-for="(src,index) in scope.row.vimageList"
                  :key="index"
                  style="width: 70px; height: 70px;margin-right: 5px;"
                  :src="src"
                  :preview-src-list="[src]"
                  fit="fill"></el-image>

              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top:20px; float:right;"
          @size-change="sizeChange"
          :current-page="page"
          @current-change="pageChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>

      </el-col>
    </el-row>
  </el-dialog-zdy>
</template>

<script>

import vfaceApi from '@/api/training/api_vface.js'
import userApi from '@/api/api_user';

export default {
  name: "vFaceImageDetails",
  data(){
    return {
      visible: false,

      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      tableLoading: true,

      detailId: undefined,
      userId: undefined,

      dataList: [],
      userInfo: {
        faceImageUrl: undefined
      }
    }
  },
  methods: {
    show(userId, detailId) {
      this.userId = userId;
      this.detailId = detailId;
      this.visible = true;

      this.loadUserInfo();
      this.search();
    },
    loadUserInfo(){
      userApi.getUser(this.userId).then(res => {
        console.log('userinfo;', res)
        if (res.code !=  500) {
          this.userInfo  = {
            faceImageUrl: res.data.faceImageUrl
          }
        }
      });
    },
    search(){
      this.page = 1;
      this.list();
    },
    list() {
      vfaceApi.detailPage({
        detailId: this.detailId,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        this.dataList = res.data.records;
        this.total = res.data.total;
        this.tableLoading =  false;
      });
    },
    sizeChange(e){
      this.pageSize = e;
      this.list();
    },
    pageChange(e) {
      this.page = e;
      this.list();
    }
  }
}
</script>

<style scoped>
  .left-box {
    text-align: center;
  }

  .left-title {
      margin-top: 30px;
      margin-bottom: 10px;
      font-weight:bold;
  }

  .image-slot {
    width:  230px;
    height:  230px;
    line-height: 230px;
    background-color: rgb(245, 247, 250);
  }
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/verification/vFaceImageDetails.vue